/* "Cookie Settings" footer link — reopens the OneTrust preference centre.

   The item is an ordinary Shopify menu link, so its label and per-market
   translations stay in Navigation / Translate & Adapt. The theme only binds
   behaviour to it.

   MATCHED BY HREF, NOT BY MARKUP
   The footer menu is rendered by snippets/footer-nav.liquid, whose anchors are
   built through 'localized-external-url'. Matching on the href keeps this
   independent of how that snippet renders and of which column the merchant
   drops the item into, rather than marking the anchor mid-loop. The fragment
   is declared once, on the footer element's data-cookie-anchor. (Kept
   deliberately identical to the Atomic theme's copy, where the link may live
   in any of three separate menus.)

   WHY A FRAGMENT
   A dedicated path (/pages/cookie-settings) gets crawled and 404s — confirmed
   on qual. A query param avoids that but creates an indexable duplicate of
   whatever page it hangs off. A fragment is not a separate URL: it never
   reaches the server and crawlers resolve it to the base page.

   OneTrust is the modern global, Optanon the legacy alias. Both expose
   ToggleInfoDisplay(); prefer OneTrust and fall back.

   "Do not sell my personal information" is deliberately NOT handled here — it
   is a plain link to a page, no on-page action. */
(function () {
  var FALLBACK = '#cookie-settings';

  /* The one fragment this script may claim, straight from the theme setting.
     Returns null to mean "disabled": a blank or degenerate value — '#' on its
     own — would otherwise match EVERY in-page anchor on the site (#login,
     #recover, the icon sprite refs) and hijack all of them. The value is
     editor-configurable, so that is reachable, not theoretical. */
  function fragment() {
    var el = document.querySelector('[data-cookie-anchor]');
    var frag = ((el && el.getAttribute('data-cookie-anchor')) || FALLBACK)
      .trim()
      .toLowerCase();
    /* Verbatim. No normalising, no prefixing, no partial matching: this
       latches on exactly the configured fragment and nothing else. Anything
       that is not a usable fragment disables the feature rather than guessing
       at what was meant. */
    if (frag.charAt(0) !== '#' || frag.length < 2) return null;
    return frag;
  }

  /* The fragment part of an href, or null. Compared WHOLE, never as a
     substring: indexOf would also match #cookie-settings-details and the
     like. */
  function hashOf(a) {
    var href = (a.getAttribute('href') || '').toLowerCase();
    var i = href.indexOf('#');
    return i === -1 ? null : href.slice(i);
  }

  function links() {
    var frag = fragment();
    var out = [];
    if (!frag) return out;
    var all = document.querySelectorAll('a[href*="#"]');
    for (var i = 0; i < all.length; i++) {
      if (hashOf(all[i]) === frag) out.push(all[i]);
    }
    return out;
  }

  function sdk() {
    var ot = window.OneTrust || window.Optanon;
    return ot && typeof ot.ToggleInfoDisplay === 'function' ? ot : null;
  }

  function open() {
    var ot = sdk();
    if (!ot) return false;
    ot.ToggleInfoDisplay();
    return true;
  }

  /* page-transition.js hijacks in-origin link clicks: it fades a full-viewport
     overlay in, then assigns location.href after 350ms. Our href is the page
     the visitor is already on, so the assignment is a no-op, no navigation
     fires, and the overlay never comes back down — the page fades to blank and
     stays there. It exempts anchors carrying data-no-transition, so tag them.
     Its own '#' exemption does not help: it tests the raw href, which here is
     /cs-cz#cookie-settings, not a bare fragment. */
  function exemptFromPageTransition() {
    var els = links();
    for (var i = 0; i < els.length; i++) els[i].setAttribute('data-no-transition', '');
  }

  /* CAPTURE, deliberately. page-transition listens on document.body and bails
     only when the click is already defaultPrevented. A bubbling listener on
     document runs AFTER body, so it would cancel too late. Capturing on
     document runs first. Belt and braces with the attribute above. */
  document.addEventListener(
    'click',
    function (e) {
      var frag = fragment();
      if (!frag) return;
      var a = e.target && e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      if (hashOf(a) !== frag) return;

      /* Cancelled whether or not the SDK answered: the fragment matches no
         element, so letting it through only jumps the page to the top. */
      e.preventDefault();
      open();
    },
    true
  );

  /* Arrived on a URL carrying the fragment (shared link, or a click that landed
     before this deferred script ran). Honour it, then strip it — the fragment
     is a trigger, not an address, and should not sit in the address bar or in
     anything the visitor copies. replaceState keeps the history length intact,
     unlike assigning location.hash. */
  function openFromUrl() {
    var frag = fragment();
    if (!frag) return;
    if (window.location.hash.toLowerCase() !== frag) return;

    if (window.history && window.history.replaceState) {
      window.history.replaceState(
        window.history.state,
        '',
        window.location.pathname + window.location.search
      );
    }
    open();
  }

  function init() {
    exemptFromPageTransition();
    openFromUrl();
  }

  /* OneTrust calls OptanonWrapper after init and on every consent change — the
     same hook snippets/onetrust-shopify-consent-bridge.liquid chains, so chain
     rather than overwrite. It is the readiness signal for the deep link: on a
     cold load the SDK is not up when this script runs. */
  var prev = window.OptanonWrapper;
  var deepLinked = false;
  window.OptanonWrapper = function () {
    if (typeof prev === 'function') {
      try {
        prev();
      } catch (err) {
        /* A throw in another consumer must not stop the deep link below. */
      }
    }
    /* Fires on every consent change too; only deep-link once, or saving a
       preference would immediately reopen the panel. */
    if (deepLinked) return;
    deepLinked = true;
    openFromUrl();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
